import React from "react"

const SliderButtonComponent = ({ watch }) => (
  <div
    className="lg:ml-40 mb-2 flex justify-center "
    style={{
      width: `${watch("desktop.button_component.button_component_width")}px`,
      height: `${watch("desktop.button_component.button_component_length")}px`,
      borderRadius: `${watch("desktop.button_component.button_curve")}%`,
      backgroundColor: `${watch("desktop.button_component.button_color")}`,
    }}
  >
    <p
      className={`flex  items-center  `}
      style={{
        color: `${watch("desktop.button_component.button_text_color")}`,
        fontSize: `${watch("desktop.button_component.button_text_size")}`,
      }}
    >
      {watch("translation.th.button_component_name")}
    </p>
  </div>
)

export default SliderButtonComponent
